export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtSNDruh';
export const NAME = 'DruhSP';
